/** @module utils/env  */

//window.location.search:设置或返回从问号 (?) 开始的 URL（查询部分
const hasToken = window.location.search.match(/token=/i) || window.location.hash.match(/token=/i);

/**
 * iOS App下载地址 家长端
 * @memberof module:utils/env
 * @constants
 * @type {string}
 * @readonly
 */
const IOS_URL = 'itms-apps://itunes.apple.com/cn/app/PRapidCalculation/id1142530651?mt=8';
const IOS_STORE_URL = 'https://itunes.apple.com/cn/app/%E4%BD%9C%E4%B8%9A%E7%9B%92%E5%AD%90%E5%B0%8F%E5%AD%A6%E5%AE%B6%E9%95%BF%E7%AB%AF/id1142530651?mt=8';

/**
 * android App下载地址 家长端
 * @memberof module:utils/env
 * @constants
 * @type {string}
 * @readonly
 */
const ANDROID_URL = 'https://appd.knowbox.cn/ss/boxgame/boxgame_141.apk';
//支持测试报告的最低家长端版本
const MIN_PARENT_APP_VERSION = 195;

/**
 * 设备类型 
 * @memberof module:utils/env
 * @enum {Symbol}
 * @readonly
 */ 
const DEVICE_TYPE = {
    /** 移动电话 */
    PHONE: Symbol(1),
    /** 平板 */
    PAD: Symbol(2),
};

/**
 * 是否是学生 
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isStudent } from 'path/to/utils/env';
 * if (isStudent()) {
 *     // TODO: A student is reading the page
 * }
 */
function isStudent() {
    return window.location.search.match(/student/i);       
}

/**
 * 是否是老师
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isTeacher } from 'path/to/utils/env';
 * if (isTeacher()) {
 *     // TODO: A teacher is reading the page
 * }
 */
function isTeacher() {
    return window.location.search.match(/teacher/i);
}

/**
 * 是否运行在App中
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isRunInApp } from 'path/to/utils/env';
 * if (isRunInApp()) {
 *     // TODO: your page is running in App environment
 * }
 */ 
function isRunInApp() {
    console.log("agent",window.navigator.userAgent.toLowerCase())
    //window.navigator.userAgent:返回由客户机发送服务器的 user-agent 头部的值。
    return window.navigator.userAgent.toLowerCase().indexOf('knowbox') > -1 || hasToken;
}

/**
 * 是否运行在微信中
 * @memberof module:utils/env
 * @function 
 * @returns {boolean}
 * @example
 * import { isRunInWeChat } from 'path/to/utils/env';
 * if (isRunInWeChat()) {
 *     // TODO: your page is running in WeChat environment
 * }
 */
function isRunInWeChat() {
    return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
}

/**
 * 是否运行在QQ中
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isRunInQQ } from 'path/to/utils/env';
 * if (isRunInQQ) {
 *     // TODO: your page is running in QQ environment
 * }
 */
function isRunInQQ() {
    return window.navigator.userAgent.match(/\sQQ/i);
}

/**
 * 是否是iOS系统
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isIOS } from 'path/to/utils/env';
 * if (isIOS()) {
 *     // TODO: your page is running in iOS Operation System
 * }
 */
function isIOS() {
    return window.navigator.userAgent.match(/(iPhone|iPod|iPad);?/i);
} 

/**
 * 是否是android系统
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isAndroid } from 'path/to/utils/env';
 * if (isAndroid()) {
 *     // TODO: your page is running in Android Operation System
 * }
 */
function isAndroid() {
    return window.navigator.userAgent.match(/android/i);
}

/**
 * 获得{@link module:utils/environment.DEVICE_TYPE 设备类型}
 * @memberof module:utils/env
 * @function
 * @returns {Symbol} 
 * @example
 * import { deviceType, DEVICE_TYPE } from 'path/to/utils/env';
 * if (DEVICE_TYPE.PAD === deviceType()) {
 *     // TODO: a Pad loads the page
 * }
 */
function deviceType() {
    const ua = window.navigator.userAgent;
    // 只有iOS设备才特码支持Pad版本样式
    if (ua.match(/pad/i) && isIOS()) {
        return DEVICE_TYPE.PAD;
    }

    return DEVICE_TYPE.PHONE;
}

/**
 * 判断是否运行在单词部落老师端
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isTwordClan } from 'path/to/utils/env';
 * if (isTwordClan()) {
 *     console.log('Yes, it is');
 * }
 */
function isTwordClan() {
    return window.navigator.userAgent.indexOf('twordclan') > -1;
}

/**
 * 判断是否运行在单词部落学生端
 * @memberof module:utils/env
 * @function
 * @returns {boolean}
 * @example
 * import { isSwordClan } from 'path/to/utils/env';
 * if (isSwordClan()) {
 *     console.log('Yes, it is');
 * }
 */
function isSwordClan() {
    return window.navigator.userAgent.indexOf('swordclan') > -1;
}

// 判断是否是安卓特殊品牌
function  isSpecialAndMobile(){
    const phone = {
        huawei : /huawei|honor/ig,
        vivo : /vivo/ig,
        xiaomi : /hm|redmi|mi/ig,
        samsung : /gt-|sm-|sch-/ig,
        coolpad : /coolpad/ig,
        meizu : /meizu/ig,
        oppo : /oppo/ig,
    }
    var ua = window.navigator.userAgent.toLowerCase();
    var a = phone.huawei.test(ua)
    var b = phone.vivo.test(ua)
    var c = phone.xiaomi.test(ua)
    var d = phone.samsung.test(ua)
    var e = phone.coolpad.test(ua)
    var f = phone.meizu.test(ua)
    var g = phone.oppo.test(ua)
    //判断手机品牌
    return (a || b || c || d || e || f || g) ? true : false;     
}
// 格式化时间
function formatTime(timestamp){
    let time = new Date(timestamp * 1000);
    // let y = time.getFullYear();
    let m = time.getMonth()+1;
    let d = time.getDate();
    return m + '月' + d + '日 ';
}

export {
    IOS_URL,
    IOS_STORE_URL,
    ANDROID_URL,
    MIN_PARENT_APP_VERSION,
    DEVICE_TYPE,
    isStudent,
    isTeacher,
    isRunInApp,
    isRunInWeChat,
    isRunInQQ,
    isIOS,
    isTwordClan,
    isSwordClan,
    isAndroid,
    deviceType,
    isSpecialAndMobile,
    formatTime
    // download,
};
